import {getProductBrandPage, getProductCategoryTree,getAllProductCategoryTree} from "@/api/product";
import {GET_PRODUCT_BRAND, GET_PRODUCT_CATEGORY_TREE} from "@/store/action-types";

const SET_PRODUCT_BRAND = 'SET_PRODUCT_BRAND';
const SET_PRODUCT_CATEGORY_TREE = 'SET_PRODUCT_CATEGORY_TREE';
const SET_ACTIVE_PRODUCT_CATEGORY_TREE = 'SET_ACTIVE_PRODUCT_CATEGORY_TREE';
const SET_ALL_PRODUCT_CATEGORY_TREE  = 'SET_ALL_PRODUCT_CATEGORY_TREE'
const state = {
  productBrands: null,
  productCategoryTree: null,
  activeProductCategoryTree: null,
  allProductCategoryTree:null
};

const mutations = {
  [SET_PRODUCT_BRAND](state, data) {
    state.productBrands = data;
  },
  [SET_ACTIVE_PRODUCT_CATEGORY_TREE](state, data) {
    state.activeProductCategoryTree = data;
  },
  [SET_PRODUCT_CATEGORY_TREE](state, data) {
    state.productCategoryTree = data;
  },
  [SET_ALL_PRODUCT_CATEGORY_TREE](state, data) {
    state.allProductCategoryTree = data;
  },
};

const actions = {
  [GET_PRODUCT_BRAND]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getProductBrandPage({
        current: 1,
        model: {},
        size: 99999
      }).then(data => {
        commit(SET_PRODUCT_BRAND, (data && data.records) || []);
        resolve();
      }).catch(error => {
        reject(error);
      })
    });
  },
  [GET_PRODUCT_CATEGORY_TREE]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getProductCategoryTree().then(data => {
        commit(SET_PRODUCT_CATEGORY_TREE, data || []);
        resolve();
      }).catch(error => {
        reject(error);
      });
      // active tree
      getProductCategoryTree({isActive: true}).then(data => {
        commit(SET_ACTIVE_PRODUCT_CATEGORY_TREE, data || []);
        resolve();
      }).catch(error => {
        reject(error);
      });

      getAllProductCategoryTree().then(data => {
        commit(SET_ALL_PRODUCT_CATEGORY_TREE, data || []);
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
